import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'

const vue = new Vue()

const state = {
  /*
  * 部门管理
  * */
  departManangeList: [],
  departManangeMark: 0,
  /*
  * 角色管理
  * */
  roleManageList: {},
  roleManageMark: 0,
  roleManageMenu: {
    list: {}, // 菜单列表
    permission: {} // 权限
  },
  roleManageData: {
    list: {}, // 数据中心权限列表
    permission: {} // 权限
  },
  /*
  * 账号管理
  * */
  accountManageList: {},
  accountSelect: [], // 下拉框
  accountManageMark: 0,

  /**
   * 人员管理
   */
  personnelManageList: {},
  personnelInfo: {},
  personnelRoleList: {},
  personnelDataRole: [],
  personnelmenuRole: [],
  personnelManageMark: 0,
  /**
   * 仓库人员管理
   */
  warehousePeopleManageList: []
}

const actions = {
  /*
  * 部门管理
  * */
  // 获取列表
  [types.GETDEPTTREE] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/dept/getDeptTree', params).then(data => {
        context.commit(types.GETDEPTTREE, data)
        resolve(data.obj)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 新增
  [types.ADDDEPT] (context, params) {
    http.fetch('/api/dept/addDept', params).then(data => {
      context.commit(types.ADDDEPT, data)
    })
  },
  // 编辑
  [types.EDITDEPT] (context, params) {
    http.fetch('/api/dept/updateDept', params).then(data => {
      context.commit(types.EDITDEPT, data)
    })
  },
  // 删除
  [types.DELDEPART] (context, params) {
    http.fetch('/api/dept/deleteDept', params, null, true).then(data => {
      context.commit(types.DELDEPART, data)
    })
  },
  // 获取地区列表
  [types.GETCITYS] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/city/getCity', params).then(data => {
        if (data.code === 200) {
          // console.log(data)
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  /*
  * 账号管理
  * */
  // 列表
  [types.GETUSERPAGES] (context, params) {
    http.fetch('/api/powerUser/getUserPage', params).then(data => {
      context.commit(types.GETUSERPAGES, data)
    })
  },
  // 新增
  [types.USERADD] (context, params) {
    http.fetch('/api/powerUser/add', params).then(data => {
      context.commit(types.USERADD, data)
    })
  },
  // 编辑
  [types.USERUPDATE] (context, params) {
    http.fetch('/api/powerUser/update', params).then(data => {
      context.commit(types.USERUPDATE, data)
    })
  },
  // 删除
  [types.USERDEL] (context, params) {
    http.fetch('/api/powerUser/del', params).then(data => {
      context.commit(types.USERDEL, data)
    })
  },
  // 禁用 / 启用
  [types.USERDISABLED] (context, params) {
    http.fetch('/api/powerUser/update', params).then(data => {
      context.commit(types.USERDISABLED, data)
    })
  },
  // 重置密码
  [types.USERRESETPWD] (context, params) {
    http.fetch('/api/powerUser/resetPwd', params).then(data => {
      context.commit(types.USERRESETPWD, data)
    })
  },
  // 下拉框 - 配置角色
  [types.GETUSERROLE] (context, params) {
    http.fetch('/api/powerUser/getUserRole', params).then(data => {
      context.commit(types.GETUSERROLE, data)
    })
  },
  /*
  * 角色管理
  * */
  // 获取列表
  [types.GETTENANTROLEPAGE] (context, params) {
    http.fetch('/api/role/getTenantRolePage', params).then(data => {
      context.commit(types.GETTENANTROLEPAGE, data)
    })
  },
  // 新增
  [types.ADDTENANTROLE] (context, params) {
    http.fetch('/api/role/addTenantRole', params).then(data => {
      context.commit(types.ADDTENANTROLE, data)
    })
  },
  // 编辑
  [types.UPDATETENANTROLE] (context, params) {
    http.fetch('/api/role/updateTenantRole', params).then(data => {
      context.commit(types.UPDATETENANTROLE, data)
    })
  },
  // 菜单权限 - 获取列表
  [types.GETMENUROLETREES] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/menu/getMenuRoleTree', params).then(data => {
        context.commit(types.GETMENUROLETREES, data)
        resolve()
      })
    })
  },
  // 菜单权限 - 获取该用户的菜单权限
  [types.SELECTMENUBYROLEID] (context, params) {
    http.fetch('/api/role/selectMenuByRoleId', params).then(data => {
      context.commit(types.SELECTMENUBYROLEID, data)
    })
  },
  // 菜单权限 - 保存
  [types.SETMENUBYROLEID] (context, params) {
    http.fetch('/api/role/setMenuByRoleId', params, 'application/json').then(data => {
      context.commit(types.SETMENUBYROLEID, data)
    })
  },
  // 数据中心权限 - 获取列表
  [types.GETWAREHOUSELIST] (context, params) {
    http.fetch('/api/warehouse/getWarehouseList', params).then(data => {
      context.commit(types.GETWAREHOUSELIST, data)
    })
  },
  // 数据中心权限 - 获取权限
  [types.SELECTDATABYROLEID] (context, params) {
    http.fetch('/api/role/selectDataByRoleId', params).then(data => {
      context.commit(types.SELECTDATABYROLEID, data)
    })
  },
  // 数据中心权限 - 保存
  [types.SETDATABYROLEID] (context, params) {
    http.fetch('/api/role/setDataByRoleId', params).then(data => {
      context.commit(types.SETDATABYROLEID, data)
    })
  },
  /**
   * 人员管理
   */
  // 列表查询
  [types.GETPERSONNELLIST] (context, params) {
    http.fetch('/api/personnel/getPersonnelList', params).then(data => {
      context.commit(types.GETPERSONNELLIST, data)
    })
  },
  // 删除人员
  [types.DELPERSONNEL] (context, params) {
    http.fetch('/api/personnel/delPersonnel', params).then(data => {
      context.commit(types.DELPERSONNEL, data)
    })
  },
  // 获取人员信息
  [types.GETPERSONNEL] (context, params) {
    http.fetch('/api/personnel/getPersonnel', params).then(data => {
      context.commit(types.GETPERSONNEL, data)
    })
  },
  // 保存人员
  [types.SAVEPERSONNEL] (context, params) {
    http.fetch('/api/personnel/savePersonnel', params).then(data => {
      context.commit(types.SAVEPERSONNEL, data)
    })
  },
  // 更新人员角色
  [types.SAVEPERSONNELRULES] (context, params) {
    http.fetch('/api/personnel/savePersonnelRules', params).then(data => {
      context.commit(types.SAVEPERSONNELRULES, data)
    })
  },
  // 查询角色
  [types.GETTENANTROLEDROP] (context, params) {
    http.fetch('/api/role/getTenantRoleDrop', params).then(data => {
      context.commit(types.GETTENANTROLEDROP, data)
    })
  },
  /**
   * 仓库人员管理
   */
  // 列表查询
  [types.GETWAREHOUSEDEPTTREE] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/dept/getWarehouseDeptTree', params).then(data => {
        context.commit(types.GETWAREHOUSEDEPTTREE, data)
        resolve(data.obj)
      }).catch(error => {
        reject(error)
      })
    })
  }

}

const mutations = {
  /*
  * 部门管理
  * */
  // 获取列表
  [types.GETDEPTTREE] (state, data) {
    state.departManangeList = data.obj
  },
  // 新增
  [types.ADDDEPT] (state, data) {
    if (data.code === 200) {
      state.departManangeMark = 1
      vue.$message.success('新增成功')
    }
  },
  // 编辑
  [types.EDITDEPT] (state, data) {
    if (data.code === 200) {
      state.departManangeMark = 1
      vue.$message.success('编辑成功')
    }
  },
  // 删除
  [types.DELDEPART] (state, data) {
    if (data.code === 200) {
      state.departManangeMark = 1
      vue.$message.success('删除成功')
    } else {
      let tips = data.message
      vue.$confirm(tips, '提示', {
        confirmButtonText: '知道了',
        showCancelButton: false,
        type: 'warning'
      }).then(() => {
        state.departManangeMark = 1
      })
    }
  },
  /*
  /*
  * 角色管理
  * */
  // 获取列表
  [types.GETTENANTROLEPAGE] (state, data) {
    state.roleManageList = data
  },
  // 新增
  [types.ADDTENANTROLE] (state, data) {
    if (data.code === 200) {
      state.roleManageMark = 1
      vue.$message.success('新增成功')
    }
  },
  // 编辑
  [types.UPDATETENANTROLE] (state, data) {
    if (data.code === 200) {
      state.roleManageMark = 1
      vue.$message.success('编辑成功')
    }
  },
  // 菜单权限 - 获取列表
  [types.GETMENUROLETREES] (state, data) {
    state.roleManageMenu.list = data.obj
  },
  // 菜单权限 - 获取该用户的菜单权限
  [types.SELECTMENUBYROLEID] (state, data) {
    state.roleManageMenu.permission = data.obj
  },
  // 菜单权限 - 保存
  [types.SETMENUBYROLEID] (state, data) {
    if (data.code === 200) {
      state.roleManageMark = 1
      vue.$message.success('编辑成功')
    }
  },
  // 数据中心权限 - 获取列表
  [types.GETWAREHOUSELIST] (state, data) {
    state.roleManageData.list = data.obj
  },
  // 数据中心权限 - 获取权限
  [types.SELECTDATABYROLEID] (state, data) {
    state.roleManageData.permission = data.obj.split(',')
  },
  // 数据中心权限 - 保存
  [types.SETDATABYROLEID] (state, data) {
    if (data.code === 200) {
      state.roleManageMark = 1
      vue.$message.success('编辑成功')
    }
  },
  /*
  * 账号管理
  * */
  // 列表
  [types.GETUSERPAGES] (state, data) {
    state.accountManageList = data
  },
  // 新增
  [types.USERADD] (state, data) {
    if (data.code === 200) {
      state.accountManageMark = 1
      vue.$message({
        showClose: true,
        message: '添加成功',
        type: 'success'
      })
    }
  },
  // 编辑
  [types.USERUPDATE] (state, data) {
    if (data.code === 200) {
      state.accountManageMark = 1
      vue.$message({
        showClose: true,
        message: '编辑成功',
        type: 'success'
      })
    }
  },
  // 删除
  [types.USERDEL] (state, data) {
    console.log(data)
    if (data.code === 200) {
      state.accountManageMark = 1
      vue.$message({
        showClose: true,
        message: '删除成功',
        type: 'success'
      })
    }
  },
  // 禁用 / 启用
  [types.USERDISABLED] (state, data) {
    if (data.code === 200) {
      state.accountManageMark = 1
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  },
  // 重置密码
  [types.USERRESETPWD] (state, data) {
    if (data.code === 200) {
      state.accountManageMark = 1
      vue.$message({
        showClose: true,
        message: '重置成功',
        type: 'success'
      })
    }
  },
  // 下拉框 - 配置角色
  [types.GETUSERROLE] (state, data) {
    state.accountSelect = data.obj
  },
  /**
   * 人员管理
   */
  [types.GETPERSONNELLIST] (state, data) {
    console.log(data)
    state.personnelManageList = data
  },
  [types.DELPERSONNEL] (state, data) {
    if (data.code !== 200) return
    state.personnelManageMark = 1
    vue.$message({
      showClose: true,
      message: '已删除',
      type: 'success'
    })
  },
  [types.GETPERSONNEL] (state, data) {
    state.personnelInfo = data
  },
  [types.SAVEPERSONNEL] (state, data) {
    if (data.code !== 200) return
    state.personnelManageMark = 1
    vue.$message({
      showClose: true,
      message: '保存成功',
      type: 'success'
    })
  },

  [types.SAVEPERSONNELRULES] (state, data) {
    if (data.code !== 200) return
    vue.$message({
      showClose: true,
      message: '保存成功',
      type: 'success'
    })
    state.personnelManageMark = 1
  },
  [types.GETTENANTROLEDROP] (state, data) {
    if (data.obj.length !== 0) {
      if (data.obj[0].type === 0) {
        state.personnelmenuRole = data.obj// 菜单角色
      } else {
        state.personnelDataRole = data.obj// 数据中心角色
      }
    }
  },
  /**
   * 仓库人员管理
   */
  [types.GETWAREHOUSEDEPTTREE] (state, data) {
    state.warehousePeopleManageList = data.obj
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/systemConfig/index.js